/**
 * Class representing an Event Handler.
 * This class is part of a chain of responsibility pattern for handling events.
 */
export class EventHandler {
  /**
   * The next handler in the chain.
   * @private
   * @type {EventHandler | null}
   */
  _next = null

  /**
   * Sets the next handler in the chain.
   * @param {EventHandler} next - The next handler to be called if this handler doesn't process the event.
   */
  setNext(next) {
    this._next = next
    return this._next
  }

  /**
   * Handles an event and passes it to the next handler if available.
   * This method should be overridden by subclasses to provide specific handling logic.
   * @param {import('./event').Event} event - The event to be handled.
   */
  handle(event) {
    if (this._next) {
      this._next.handle(event)
    }
  }
}
